module.exports = __webpack_public_path__ + "img/sellers.2f18fc0d.svg";